// extracted by mini-css-extract-plugin
export default {"Box":"Box_Box__dH0mZ"};